import { render, staticRenderFns } from "./Brands.vue?vue&type=template&id=3f57d059&"
import script from "./Brands.vue?vue&type=script&lang=ts&"
export * from "./Brands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports